import { createStrings } from '@utils/local';
import { PageMeta } from '@utils/pages';

const strings = createStrings({
  ja: {
    title: 'D2D会員開設申請',
  },
});

export const meta: PageMeta = {
  title: strings.title,
  order: 2,
  staffOnly: true,
  rolesOnly: ['admin', 'FCJapan'],
};
